module.exports = __webpack_public_path__ + "img/computer.1929e72f.png";